import { parse } from "date-fns";
import { formatRange } from "../utils/helpers";
import { t } from "../i18n";

export const BookingExpressHourSelection = ({ hours, selected, onSelect }) => {
	const getSlotLabel = (slot) => {
		const dropoffDate = parse(slot.dropoff, "HH:mm", new Date());
		const pickupDate = parse(slot.pickup, "HH:mm", new Date());

		const isMorning =
			dropoffDate.getHours() < 12 && pickupDate.getHours() <= 15;
		const isAfternoon =
			dropoffDate.getHours() >= 12 && pickupDate.getHours() <= 20;

		if (isMorning) return t("Mañana express");
		if (isAfternoon) return t("Tarde express");
		return t("Flexible");
	};

	const allUnavailable = hours.every(
		(group) =>
			!group ||
			group.length === 0 ||
			group.every((slot) => !slot.available)
	);

	if (allUnavailable) {
		return (
			<div className="content_time_info no-availability">
				<h4>{t("No se han podido cargar las horas disponibles")}</h4>
				<p>
					{t(
						"Por favor, intenta de nuevo más tarde o contáctanos para ayudarte a gestionar tu cita."
					)}
				</p>
			</div>
		);
	}

	return (
		<div className="content_time">
			{hours.map((group, groupIndex) =>
				group.map((slot, slotIndex) => {
					const label = getSlotLabel(slot);
					const dropoffRange = formatRange(slot.dropoff, 0, 30);
					const pickupRange = formatRange(slot.pickup, -15, 0);
					const isSelected =
						selected === slot.dropoff + "-" + slot.pickup;

					return (
						<div
							key={`${groupIndex}-${slotIndex}`}
							className={`content_time_slot kensei_03${
								isSelected ? " selected" : ""
							}${!slot.available ? " disabled" : ""}`}
							onPointerDown={onSelect(slot)}
						>
							<p className="slot_title">{label}</p>
							<div className="slot_times">
								<div className="slot_row">
									<p>{t("Entrega")}</p>
									<div>
										<img
											src="resources/icons/dropoff.svg"
											alt="Entrega"
										/>
										<span>{dropoffRange}</span>
									</div>
								</div>
								<div className="slot_row">
									<p>{t("Recogida")}</p>
									<div>
										<img
											src="resources/icons/pickup.svg"
											alt="Recogida"
										/>
										<span>{pickupRange}</span>
									</div>
								</div>
							</div>
						</div>
					);
				})
			)}
		</div>
	);
};
